import createLucideIcon from '../createLucideIcon';

const ChevronsLeftRight = createLucideIcon('ChevronsLeftRight', [
  ['path', { d: 'm9 7-5 5 5 5', key: 'j5w590' }],
  ['path', { d: 'm15 7 5 5-5 5', key: '1bl6da' }],
]);

export default ChevronsLeftRight;
